import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function CattleImport() {
  const navigate = useNavigate();
  const [csvText, setCsvText] = useState('');
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [result, setResult] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr(''); setResult(null);
    try {
      let csv = csvText;
      if (file && !csv.trim()) {
        csv = await file.text();
      }
      if (!csv.trim()) throw new Error('paste CSV or upload a file');
      const r = await api.post('/api/cattle/import-adca', { csv });
      setResult(r);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="space-y-4 max-w-2xl">
      <header>
        <h1 className="text-2xl font-serif text-olive-900">Import ADCA CSV</h1>
        <p className="text-sm text-ink-700/70 mt-1">
          Paste a CSV or upload a file from members.dextercattle.org. Idempotent on ADCA Reg #.
          Recognized columns: <span className="font-mono text-xs">Reg #, Name, DOB, Sex, Color, Polled, A2/A2, PHA, Chondro, Ear Tag</span>.
        </p>
      </header>

      <div className="card space-y-3">
        <div>
          <label className="label">Upload CSV</label>
          <input
            type="file"
            accept=".csv,text/csv"
            className="block w-full text-sm file:mr-3 file:rounded-md file:border-0 file:bg-olive-700 file:text-cream-50 file:px-3 file:py-2 file:font-medium hover:file:bg-olive-900"
            onChange={e => setFile(e.target.files?.[0] || null)}
          />
        </div>
        <div className="text-xs text-ink-700/60 text-center">— or —</div>
        <div>
          <label className="label">Paste CSV</label>
          <textarea
            className="input font-mono text-xs"
            rows={10}
            value={csvText}
            onChange={e => setCsvText(e.target.value)}
            placeholder='Reg #,Name,DOB,Sex,Color,Polled,A2/A2,PHA&#10;ADCA-12345,Bessie,2020-04-12,Cow,Black,PP,A2A2,non-carrier'
          />
        </div>
      </div>

      {err && <div className="bg-rust-500/10 text-rust-700 rounded-md px-3 py-2 text-sm">{err}</div>}

      {result && (
        <div className="card bg-olive-50 space-y-2">
          <h2 className="font-medium text-olive-900">Import result</h2>
          <ul className="text-sm space-y-1">
            <li><strong>{result.imported}</strong> new animals imported</li>
            <li><strong>{result.updated}</strong> existing animals updated</li>
            <li><strong>{result.skipped}</strong> rows skipped (no Reg #)</li>
            {result.errors?.length > 0 && (
              <li className="text-rust-700">
                <strong>{result.errors.length}</strong> errors:
                <ul className="list-disc ml-5 mt-1 text-xs">
                  {result.errors.slice(0, 5).map((e, i) => (
                    <li key={i}>row {e.row} ({e.reg}): {e.error}</li>
                  ))}
                </ul>
              </li>
            )}
          </ul>
          <div className="flex gap-2 pt-2">
            <button type="button" onClick={() => navigate('/cattle')} className="btn-primary">View herd</button>
            <button type="button" onClick={() => { setResult(null); setCsvText(''); setFile(null); }} className="btn-ghost">Import another</button>
          </div>
        </div>
      )}

      {!result && (
        <div className="flex gap-2">
          <button type="button" onClick={() => navigate('/cattle')} className="btn-ghost">Cancel</button>
          <button className="btn-primary" disabled={busy}>{busy ? 'Importing…' : 'Import'}</button>
        </div>
      )}
    </form>
  );
}
